export default {
  placesCarousel: {
    'layer': 'Layer',
    'lat': 'Lat.',
    'lon': 'Long.',
    'notAvailable': 'Non avviabile',
    'placeDetails': 'Detagli del luogo',
    'next': 'Prossima pagina',
    'prev': 'Pagina precedente',
    'directionsTo': 'Direzioni per',
    'distance': 'Distanza',
    'distanceFromLocationMarkedOnTheMap': 'Distanza approssimata dal luogo segnato',
    'selectPlace': 'Seleziona'
  }
}
